import React from 'react';
import { Modal } from 'react-bootstrap';
import NodeForm from './NodeForm';
import { Node } from 'reducers/nodesReducer';
import { Script } from 'reducers/scriptReducer';

type TEnableNodePopup = {
  node: Node;
  onClose: () => void;
  onSave: (_: Node) => void;
  pending: boolean;
  aetsAlreadyTaken: string[];
  onDicomEchoClick: (_: Node) => void;
  scripts: Script[];
};

export default function EnableNodePopup({
  node,
  onClose,
  onSave,
  pending,
  aetsAlreadyTaken,
  onDicomEchoClick,
  scripts
}: TEnableNodePopup): React.ReactElement {
  return (
    <Modal show size="lg">
      <Modal.Header>
        <Modal.Title>Enabling node {node.aeTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <NodeForm
          aetsAlreadyTaken={aetsAlreadyTaken}
          node={{ ...node, enabled: true, forwardFavorite: false }}
          onClose={onClose}
          onSave={onSave}
          pending={pending}
          saveButtonLabels={['Enable node', 'Enabling..']}
          nodes={[] as string[]}
          onDicomEcho={onDicomEchoClick}
          scripts={scripts}
        />
      </Modal.Body>
    </Modal>
  );
}
